<nb-card class="note-modal">
  <nb-card-header>یادداشت</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-12 col-lg-6">
        <nb-card class="mb-0" accent="success">
          <nb-card-header>یادداشت جدید</nb-card-header>
          <nb-card-body>
            <div class="mb-3">
              <textarea
                rows="4"
                [status]="error['message'] !== undefined ? 'danger' : 'basic'"
                name="note"
                [(ngModel)]="note.message"
                fullWidth
                nbInput
                placeholder="متن یادداشت"
              ></textarea>
              <app-validation-error [errors]="error" name="message"></app-validation-error>
            </div>
            <button
              [nbSpinner]="saveLoading"
              [disabled]="saveLoading"
              nbButton
              (click)="saveNewNote()"
              status="primary"
            >
              ارسال
            </button>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-12 col-lg-6">
        <nb-card accent="primary" class="note-list-container mb-0">
          <nb-card-header>یادداشت‌های کاربر</nb-card-header>
          <nb-card-body>
            <ng-container *ngIf="notes$ | async as notes; else skeletonTemplate">
              <ng-container *ngIf="notes.length > 0; else noMessageTemplate"></ng-container>
              <nb-card *ngFor="let note of notes$ | async">
                <nb-card-header class="py-1 px-2">
                  <div class="d-flex align-items-center justify-content-between">
                    <small>{{ note.adminUser.firstName }} {{ note.adminUser.lastName }}</small>
                    <small>{{ note.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}</small>
                  </div>
                </nb-card-header>
                <nb-card-body class="px-2">{{ note.message }}</nb-card-body>
              </nb-card>
            </ng-container>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
  </nb-card-body>
</nb-card>
<ng-template #noMessageTemplate>
  <h5 class="d-flex justify-content-center align-items-center h-100 m-0 text-center">
    پیامی برای این کاربر هنوز ثبت نشده است.
  </h5>
</ng-template>
<ng-template #skeletonTemplate>
  <nb-card class="note" *ngFor="let _ of skeleton">
    <nb-card-header>
      <ngx-skeleton-loader
        class="d-flex"
        [theme]="{ width: '200px', height: '20px' }"
        animation="progress-dark"
        count="1"
      ></ngx-skeleton-loader>
    </nb-card-header>
    <nb-card-body>
      <ngx-skeleton-loader
        [theme]="{ width: '100%', height: '60px' }"
        animation="progress-dark"
        count="1"
      ></ngx-skeleton-loader>
    </nb-card-body>
  </nb-card>
</ng-template>
